export default __webpack_public_path__ + "static/media/eLoader2.f3f5647c.gif";